import { Patient } from "@/store/modules/patient/types";
import SVG from "svg.js";
import { Store } from "vuex";
import { BodyConfig } from ".";
import { InfoWindow } from "./InfoWindow";

export class LungRateOnlyText extends InfoWindow {
  shiftX = 310;
  shiftY = 195;

  constructor(config: BodyConfig, container: SVG.Container, store: Store<any>) {
    super(config, container, store);
    this.shiftContent();
  }

  getExtraData(patient: Patient) {
    this.atom = this.getAtom(patient);
    const line1 = "RR at Rest";
    const line2 =
      this.atom && this.atom.legend && this.atom.legend.replace("]", " ago]");

    this.extraData = {
      line1,
      line2
    };
  }
}
